import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';
import type { InboxEmailStatus } from '../types/inbox.types';

type Variables = {
  emailId: string;
  spaceId: string;
  status: InboxEmailStatus;
};

async function updateEmailStatus(variables: Variables) {
  const { data, error } = await apiClient
    .from('inbox_emails')
    .update({
      status: variables.status,
      updated_at: new Date().toISOString(),
    })
    .eq('id', variables.emailId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useUpdateEmailStatus() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEmailStatus,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: keys.inbox });
      const label =
        variables.status === 'processed'
          ? 'Email marqué comme traité.'
          : variables.status === 'ignored'
          ? 'Email ignoré.'
          : 'Email restauré.';
      enqueueSnackbar(label, 'success');
    },
    onError: (err: Error) => {
      enqueueSnackbar(err.message || 'Impossible de mettre à jour le statut.', 'error');
    },
  });
}
